(() => {
  class CrossSellItems extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._flkty = null;
    }

    connectedCallback() {
      if (this._initialized) return;

      let crossSellEl = document.querySelector('cross-sell-items .carousel');
      if (!crossSellEl) crossSellEl = this;

      if (typeof Flickity === 'undefined') return;

      this._flkty = new Flickity(crossSellEl, {
        groupCells: false,
        pageDots: false,
        draggable: true,
        cellAlign: 'left',
        bgLazyLoad: 1,
        prevNextButtons: true,
        wrapAround: false,
        contain: true,
        imagesLoaded: true,
        adaptiveHeight: false
      });


      // setTimeout(() => {
      //   const viewport = crossSellEl.querySelector('.flickity-viewport');
      //   const card = crossSellEl.querySelector('.product-card-wrapper');
      //   if (viewport && card) viewport.style.height = card.offsetHeight + 'px';
      // }, 500);

      this._initialized = true;
    }

    disconnectedCallback() {
      const viewport = this.querySelector('.flickity-viewport') || document.querySelector('cross-sell-items .flickity-viewport');
      if (viewport) {
        const cards = viewport.querySelectorAll('.product-card-wrapper');
        cards.forEach((card) => {
          card.style.height = '';
        });
      }

      if (this._flkty && typeof this._flkty.destroy === 'function') {
        this._flkty.destroy();
        this._flkty = null;
      }
      this._initialized = false;
    }
  }

  if (!customElements.get('cross-sell-items')) {
    customElements.define('cross-sell-items', CrossSellItems);
  }
})();


